import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from 'react-intl'
import { formatPeriod } from '@/scopes/account/common/formatters'
import { MediaServerLazyImage } from '@/scopes/common/components/MediaServerLazyImage/MediaServerLazyImage'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { formatAccommodationAddress } from '../utils/accommodationAddress'
import styles from './AccommodationDetailsSection.module.css'
import { BookingDetailsSection } from './BookingDetailsSection'
import { IconRow } from './IconRow'
import { SidebarItem } from './SidebarItem'

export function AccommodationDetailsSection() {
  const { formatMessage } = useIntl()
  const locale = useConfiguration('locale')
  const accommodations = useBookingDetailsStore(state => state.accommodations)

  return (
    <>
      {accommodations.map((accommodation) => {
        const address = formatAccommodationAddress(accommodation.address)

        return (
          <BookingDetailsSection
            key={`${accommodation.name}-${accommodation.checkInDate}-${accommodation.checkOutDate}`}
            isSidebar
            className={styles.accommodationBlock}
          >
            {accommodation.imageUrl && (
              <MediaServerLazyImage
                className={styles.image}
                src={accommodation.imageUrl}
                widths={[907, 1814]}
                alt={accommodation.name}
              />
            )}
            <div className={styles.accommodationInfo}>
              <Typography className={styles.name} as="h2" variant="display-h-regular">
                {accommodation.name}
              </Typography>
              {address && (
                <div className={styles.address}>
                  <IconRow glyph="MapPin" description={address} />
                </div>
              )}
              {accommodation.url && (
                <Button
                  as="a"
                  variant="secondary"
                  size="S"
                  className={styles.button}
                  href={accommodation.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {formatMessage({ id: 'booking_details_view_accommodation' })}
                </Button>
              )}
            </div>
            <SidebarItem.Container className={styles.container} hideFirstBorder={false}>
              <SidebarItem iconName="Calendar" label={formatMessage({ id: 'booking_details_period_label' })}>
                <Typography variant="body-m-bold-tight">
                  {(() => {
                    const checkInDate = accommodation.checkInDate ?? ''
                    const checkOutDate = accommodation.checkOutDate ?? ''
                    return formatPeriod(checkInDate, checkOutDate, locale, 'long')
                  })()}
                </Typography>
              </SidebarItem>
              {!!accommodation.roomsDescription?.length && (
                <SidebarItem iconName="Bed" label={formatMessage({ id: 'booking_details_room_label' })}>
                  {accommodation.roomsDescription.map(({ description, quantity }) => (
                    <Typography key={description} variant="body-m-bold-tight">
                      {`${quantity} x ${description}`}
                    </Typography>
                  ))}
                </SidebarItem>
              )}
            </SidebarItem.Container>
          </BookingDetailsSection>
        )
      })}
    </>
  )
}
